<template>

</template>

<script>
    export default {
        name: "refresh",
        beforeCreate(){
            this.$router.push('/careerArchives')
        }
    }
</script>

<style scoped>

</style>
